import { combineReducers } from "redux";
import {
  forgetPassword,
  auth,
  userDetailOTPForgotPass
} from "../login/authReducer";
import systemConfig from "./systemConfig";
import update from "./updateData";
import sectionMaster from "./getAllSection";
import syllabusMaster from "./getAllSyllabus";
import admissionFormList from "./getAllAdmissionFormList";
import common from "./getCommonAll";
import countryStateCity from "./getCountryStateCity";
import userDetails from "./getUserDetailsByUserId";
import qualificationConfigList from "./getQualificationConfigurationByFormId";
import achievementList from "./getAllAchievements";
import profileLanguageList from "./getAllProfileLanguages";
import achievementByStudent from "./getAchivementsByStudentId";
import languageKnownByStudent from "./getProfileLanguagesByStudentId";
import documentChecklist from "./getAllDocumentChecklistByFormId";
import quotaList from "./getAllQuota";
import admissionProgram from "./getAllAdmissionProgram";
import admissionFormConfiguration from "./getAllAdmissionFormConfigurationByFormId";
import admissionSubjectGroupList from "./getAllAdmissionSubjectGroupByFormId";

import admissionExperienceDetails, {
  internshipDetails,
  entranceExaminationDetails,
  degreeRegistrationDetails,
  admissionFormLookups,
  neetDetails
} from "./getExperienceDetailsByStudentId";
import admissionOtherDetails from "./getOtherDetailsByStudentId";
import admissionResearchDetails from "./getResearchDetailsByStudentId";
import admissionWorkingDetails from "./getWorkingInstituteDetailsByStudentId";
import academicQuotaList from "./getAcademicQuotaDetailsByStudentId";
import admissionVerifyDetails from "./getFormVerifyDetailsByStudentId";
import admissionTotalFormFees from "./getAdmissionTotalFormFeesByStudentId";
import userRegistrationDetails from "./userRegistrationDetails";
import admissionApplyThrough from "./getAllApplyThroughList";
import admissionBoard from "./getAllBoardList";
import admissionMedium from "./getAllMediumList";
import admissionMarksType from "./getAllMarksTypeList";
import admissionACPCdetails from "./getACPCdetailsByStudentId";

import admissionStudentStatusDetails from "./getApplicationStatusByStudentId";
import advertisementList from "./getAllAdvertisement";
import paymentvendorlist from "./paymentvendorsList";
import admissionCounsellingDetail from "./getAllCounsellingDetailByStudentId";
import admissionTuitionFeesDetails from "./getStudentFeesDetailByFeesTransactionMstId";
import admissionDocumentVerificationStatus from "./getDocumentVerificationStatusByStudentId";

import admissionPhysicallychallenge from "./getAllPhysicallyChallengeCategory";

import admissionConfiguration from "./getAdmissionConfiguration";

export default combineReducers({
  auth,
  forgetPassword,
  userDetailOTPForgotPass,

  systemConfig,
  update,
  sectionMaster,
  syllabusMaster,
  admissionFormList,
  common,
  countryStateCity,
  userDetails,
  qualificationConfigList,
  achievementList,
  profileLanguageList,
  achievementByStudent,
  languageKnownByStudent,
  documentChecklist,
  quotaList,
  admissionProgram,
  admissionFormConfiguration,
  admissionSubjectGroupList,

  admissionExperienceDetails,
  admissionOtherDetails,
  admissionResearchDetails,
  admissionWorkingDetails,
  academicQuotaList,
  admissionVerifyDetails,
  admissionTotalFormFees,
  userRegistrationDetails,

  admissionApplyThrough,
  admissionBoard,
  admissionMedium,
  admissionMarksType,
  admissionACPCdetails,
  admissionStudentStatusDetails,
  advertisementList,
  paymentvendorlist,
  admissionCounsellingDetail,
  admissionTuitionFeesDetails,
  admissionDocumentVerificationStatus,
  admissionPhysicallychallenge,
  admissionConfiguration,
  internshipDetails,
  entranceExaminationDetails,
  degreeRegistrationDetails,
  admissionFormLookups,
  neetDetails
});



// WEBPACK FOOTER //
// ./src/reducers/index.js